import React, {useEffect, useState} from "react";
import {Contract} from "web3-eth-contract";
import {useAllowance, useApprove} from "../../web3/use_fn/token_server";
import {useSendModal} from "../../model/http_loading";
import styled from "styled-components";
import {HttpStatus, useWait} from "../../utils/wait_fn";
import {CircularProgress} from "@material-ui/core";


export const ApproveButton: React.FC<{ contract: Contract, contractAddress: string, spender: string }> = ({
                                                                                                              contract,
                                                                                                              contractAddress,
                                                                                                              spender
                                                                                                          }) => {

    const [approve] = useApprove(contract, contractAddress, spender); // 授权方法

    const handleApprove = useSendModal(approve); // 申请授权


    return (
        <div>
            <ApproveStyle onClick={handleApprove}>
                Approve
            </ApproveStyle>
        </div>
    );
}


export const IsApprove: React.FC<{
    erc20: Contract | undefined,
    spender: string | undefined,
    erc20Address: string | undefined,
}> = ({
          erc20,
          spender,
          erc20Address,
          children
      }) => {


    const allowance = useAllowance(erc20, spender || '');

    return (
        <div style={{width:'100%'}}>
            {
                erc20Address && erc20 && spender ?
                    allowance <= 0 ?
                        <ApproverStatus contract={erc20} contractAddress={erc20Address}
                                        spender={spender}>{children}</ApproverStatus>

                        : children :
                    children
            }
        </div>
    );
}

const ApproverStatus: React.FC<{ contract: Contract, contractAddress: string, spender: string }> = ({
                                                                                                        contract,
                                                                                                        contractAddress,
                                                                                                        spender,
                                                                                                        children
                                                                                                    }) => {

    const [approve] = useApprove(contract, contractAddress, spender || ''); // 授权方法
    const {request, status} = useWait(approve);
    const [widget, setWidget] = useState(children);
    useEffect(() => {
        switch (status) {
            case HttpStatus.failure:
                setWidget(<ApproveStyle onClick={(e) => request()}>Approve</ApproveStyle>)
                break;
            case HttpStatus.start:
                setWidget(<ApproveStyle onClick={(e) => request()}>Approve</ApproveStyle>)
                break;
            case HttpStatus.wait:
                setWidget(<ApproveStyle><CircularProgress style={{color:"#fff"}}/></ApproveStyle>)
                break;
            case HttpStatus.success:
                setWidget(children);
                break;
        }
    }, [status])
    return (
        <>
            {widget}
        </>
    );
}


export const ApproveStyle = styled.div`
  height: 40px;
  width: 100%;
  border-radius: 5px;
  border: 1px solid;
  background: linear-gradient(165deg, #123DB5 0%, #5A42EC 100%);
  box-shadow: 0px 0px 32px 0px rgba(45, 70, 146, 0.2);
  text-align: center;
  line-height: 40px;
  color: white;
`
